var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccessBusiness = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7519 23.8576V26.0607C31.8594 27.1667 31.0489 28.1473 29.9429 28.2548C28.8369 28.3623 27.8563 27.5518 27.7488 26.4458C27.7354 26.3159 27.7354 26.186 27.7488 26.0607V23.8576H12.2512V26.0607C12.3587 27.1667 11.5482 28.1473 10.4422 28.2548C9.33617 28.3623 8.35554 27.5518 8.24807 26.4458C8.23464 26.3159 8.23464 26.186 8.24807 26.0607V23.8576H0V34.3267C0 37.0805 2.00157 39.288 4.50017 39.288H35.4998C37.9984 39.288 40 37.085 40 34.3267V23.8576H31.7519Z",
    fill: "url(#paint0_linear_3438_61005)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2557 20.759C12.296 19.6172 11.3959 18.6589 10.2541 18.6231C9.13019 18.7574 8.27494 19.6978 8.24807 20.8262C5.49871 20.8262 2.74936 21.1038 0 21.1038V12.8378C0 10.084 2.00157 7.8809 4.50017 7.87642H9.7526V5.67335C9.7526 2.91504 11.7542 0.711975 14.2528 0.711975H25.7517C28.2503 0.711975 30.2519 2.91952 30.2519 5.67335V7.60328H35.4998C37.9984 7.60328 40 9.81082 40 12.5647V20.8262H31.7519C31.7564 20.8038 31.7564 20.7814 31.7564 20.759C31.7967 19.6172 30.8967 18.6589 29.7548 18.6231C28.6309 18.7574 27.7757 19.6978 27.7533 20.8262H12.2512C12.2557 20.8038 12.2557 20.7814 12.2557 20.759Z",
    fill: "url(#paint1_linear_3438_61005)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3438_61005",
    x1: 20,
    y1: 23.8576,
    x2: 20,
    y2: 39.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7F741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECA25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3438_61005",
    x1: 20,
    y1: 0.711975,
    x2: 20,
    y2: 21.1038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#189EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3863D2"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccessBusiness);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/access-business.dd468a043fb852e4babce2716c4400ef.svg";